// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__S_o5s","additionalInfo":"AgreementModal_additionalInfo__27pF4"};